import { useAuth0 } from "@auth0/auth0-react";
import { HelmetProvider } from "react-helmet-async";
import { ErrorProvider } from "~components/ErrorHandler/ErrorProvider";
import { Loader } from "./Common/Components";
import useFontLoader from "./hooks/useFontLoader";
import Routes from "./routes";

const Init = () => {
  const { loading } = useAuth0();

  const fonts = [
    {
      name: "Bebas Neue Pro",
      url: "/fonts/font/bebas-neue-pro-bold.woff2",
    },
    {
      name: "Bebas Neue Pro",
      url: "/fonts/font/bebas-neue-pro-middle.woff2",
    },
    {
      name: "Bebas Neue Pro",
      url: "/fonts/font/bebas-neue-pro-regular.woff2",
    },
    {
      name: "Bebas Neue Pro",
      url: "/fonts/font/bebas-neue-pro-light.woff2",
    },
  ];

  const fontsLoaded = useFontLoader(fonts);

  if (!fontsLoaded) {
    return (
      <HelmetProvider>
        <Loader />
      </HelmetProvider>
    );
  }

  return (
    <HelmetProvider>
      <ErrorProvider>{!loading && <Routes />}</ErrorProvider>
    </HelmetProvider>
  );
};

export default Init;
